/**
 * @function validateArray
 * @param {any} array a candidate to evaluate if it an array
 * @returns {boolean}
 */
function validateArray(array) {
  if (array === null || array === undefined) {
    return false;
  }

  if (!Array.isArray(array)) {
    return false;
  }

  return array.length > 0;
}

/**
 * @function validateString
 * @param {any} string
 * @returns {boolean}
 */
function validateString(string) {
  if (string === null || string === undefined) {
    return false;
  }

  if (String(string).trim() === '' || String(string).length <= 0 || String(string).trim().length <= 0) {
    return false;
  }

  return true;
}

/**
 * @function validateEmail
 * @param {any} email
 * @returns {boolean}
 */

function validateEmail(email) {
  if (!validateString(email)) {
    return false;
  }

  var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
  return regex.test(email);
}

/**
 * @function validateName
 * @param {any} name a string for checking if valid
 * @returns {boolean}
 */

function validateName(name) {
  if (!validateString(name)) {
    return false;
  }

  var regex = /^([a-z\u00C0-\u02AB'´`]{1,}\.?\s?)([a-z\u00C0-\u02AB'´`]?\.?\s?)+$/i;
  return regex.test(name);
}

/**
 * @function validateNumber
 * @param {any} number
 * @returns {boolean}
 */
function validateNumber(number) {
  if (number === null || number === undefined || number === false) {
    return false;
  }

  if (Array.isArray(number)) {
    return false;
  }

  if (String(number).trim().length <= 0) {
    return false;
  }

  var _number = Number(number);

  return !Number.isNaN(_number);
}

/**
 * @function validatePhone
 * @param {any} phone
 * @returns {boolean}
 */

function validatePhone(phone) {
  if (!validateString(phone)) {
    return false;
  }

  if (String(phone).length < 9) {
    return false;
  }

  if (String(phone).length >= 16) {
    return false;
  }

  var regex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
  return regex.test(String(phone));
}

export { validateArray, validateEmail, validateName, validateNumber, validatePhone, validateString };
//# sourceMappingURL=avilatek-utils.esm.js.map
